import React from 'react'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import LiquidSelectAdapter from '@src/components/LiquidSelectAdapter'
import { Grid, Box } from '@material-ui/core'
import { Formik, Field } from 'formik'
import { PerPageValues } from '@src/routes/SemiConfigurators/products/sirna/enum'
import { configContext } from '../Sirna'
import useStyles from '@src/routes/SemiConfigurators/utils/styles'

const PerPage = () => {
  const classes = useStyles()
  const { state, dispatch } = React.useContext(configContext)
  const countForAllData = state.searchResult.count

  const onPerPageChange = (event): void => {
    if (state.stepNo) {
      dispatch({ type: 'TRACE_ON_CLICK', data: true })
    }
    dispatch({
      type: 'UPDATE_TOTAL_PRICE',
      data: '',
    })
    dispatch({
      type: 'UPDATE_SELECTED_DATA',
      data: [],
    })
    dispatch({
      type: 'UPDATE_CHECKED_ALL',
      data: false,
    })
    const value = event.target.value
    let strToNumPerPage = 10
    dispatch({ type: 'SET_PER_PAGE_COUNT', data: value })

    if (value === PerPageValues.PerPageALL) {
      strToNumPerPage = countForAllData
    } else {
      strToNumPerPage = parseInt(value)
    }
    dispatch({
      type: 'SEARCH_INPUT',
      data: {
        ...state.searchInput,
        count: strToNumPerPage,
        page: 1,
      },
    })
  }

  React.useEffect(() => {
    window.scrollTo(0, 480)
  }, [state.searchInput])

  return (
    <>
      <Box>
        <Formik
          initialValues={{
            materialName: (
              <FormattedMessage
                {...messages.CONF_SPECIFICATION_PHYSICAL_MATERIAL_SYNTHETIC_RNA_crisprgrna}
              />
            ),
          }}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              actions.setSubmitting(false)
            }, 1000)
          }}
        >
          {() => (
            <>
              <Grid container className={classes.paddingGrid} direction="row">
                <Grid item xs={4} className={classes.labelStylePerPage}>
                  <FormattedMessage
                    {...messages.SEMI_CONF_PER_PAGE_crispgrna}
                  />
                </Grid>
                <Grid item xs={3} className={classes.valueStylePerPage}>
                  <Field
                    name="perPage"
                    component={LiquidSelectAdapter}
                    options={[
                      {
                        label: PerPageValues.PerPage10,
                        value: PerPageValues.PerPage10,
                      },
                      {
                        label: PerPageValues.PerPage20,
                        value: PerPageValues.PerPage20,
                      },
                      {
                        label: PerPageValues.PerPage30,
                        value: PerPageValues.PerPage30,
                      },
                      {
                        label: PerPageValues.PerPage50,
                        value: PerPageValues.PerPage50,
                      },
                      {
                        label: PerPageValues.PerPage100,
                        value: PerPageValues.PerPage100,
                      },
                      {
                        label: PerPageValues.PerPageALL,
                        value: PerPageValues.PerPageALL,
                      },
                    ]}
                    value={state.perPageCount}
                    onChange={onPerPageChange}
                    className={classes.bgColor}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Formik>
      </Box>
    </>
  )
}

export default PerPage
